<template>
  <AtomLink :url="url" class="group flex flex-col gap-6 lg:gap-6 xl:gap-8 2xl:gap-10 w-full">
    <figure class="block rounded-lg overflow-hidden">
      <MoleculePicture :image="image" />
    </figure>
    <div class="flex flex-auto gap-8 lg:gap-8 xl:gap-10 2xl:gap-12 flex-col items-start justify-start">
      <div class="flex flex-col gap-4 lg:gap-4 xl:gap-5 2xl:gap-6">
        <time v-if="date" class="leading-none text-sm xl:text-lg 2xl:text-xl">{{ $d(new Date(date), 'medium-date') }}</time>
        <h3 class="font-black sm:text-lg xl:text-2xl 2xl:text-4xl leading-tight">{{ title }}</h3>
      </div>
      <AtomButton v-if="readMore" button-type="lid-read-more" class="pr-2">
        Lees dit verhaal
        <AtomIconArrowRight :title="t_('read-story')" class="transform transition ease-in-out duration-200 ml-6 w-4 xl:ml-8 xl:w-5 group-hover:translate-x-2" />
      </AtomButton>
    </div>
  </AtomLink>
</template>

<script setup lang="ts">
import { setupTranslationPrefixer } from '~/composables/util'

interface Props {
  date?: string
  url?: string
  image: object
  readMore?: boolean
  title: string
  summary?: string
}

defineProps<Props>()

const { t_ } = setupTranslationPrefixer('lid-carousel-slide-story')
</script>
